import React, { Fragment, Component } from "react";

class FileSearch extends Component {
    handleSearchInputChange = event => {
        event.preventDefault();
        const filterName = event.target.value;
        const files = this.getFilteredFiles(filterName);

        this.setState({
            files,
            filterName
        });
    };

    handleShowDetailsForFile = (file, event) => {
        const files = this.props.files.map(f => {
            if (f.id !== file.id) {
                f.isSelected = false;
            }
            return f;
        });
        const fileIndex = files.findIndex(f => f.id === file.id);
        files[fileIndex].isSelected = !files[fileIndex].isSelected;
        if (event) {
            event.stopPropagation();
        }

        this.setState({
            files
        });
    };

    getFilteredFiles = filterName =>
        this.props.files.filter(
            file =>
                file.name.toLowerCase().indexOf(filterName.toLowerCase()) > -1
        );

    constructor(props) {
        super(props);

        this.state = {
            files: props.files,
            filterName: ""
        };

        this.fileSearchInput = React.createRef();
    }

    componentDidMount() {
        this.fileSearchInput.current.focus();
    }

    render() {
        const { filterName } = this.state;
        let files = [];
        if (filterName != "") {
            files = this.getFilteredFiles(filterName);
        }

        return (
            <Fragment>
                <div className="row mt-3">
                    <div className="col-sm-8 col-xl-6">
                        <div className="form-group">
                            <input
                                className="form-control form-control-sm"
                                onChange={event =>
                                    this.handleSearchInputChange(event)
                                }
                                placeholder="Vad letar du efter?"
                                ref={this.fileSearchInput}
                            />
                        </div>
                    </div>
                </div>
                {files.length === 0 && filterName != "" && (
                    <div className="row">
                        <div className="col-sm-8 col-xl-6">
                            <em>Hittade inga filer som matchar</em>
                        </div>
                    </div>
                )}
                {files.length > 0 && filterName != "" && (
                    <div className="stripedRows">
                        {files.map(file => (
                            <div className="row pt-2 pb-2">
                                <div className="col-sm-2 col-xl-1">
                                    <a
                                        onClick={event =>
                                            this.props.onAttachFile(event, file)
                                        }
                                        role="button"
                                        tabIndex="0"
                                        title="Välj för att lägga till"
                                    >
                                        {file.name}
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Fragment>
        );
    }
}

export default FileSearch;
